import { PhoneFormatter } from 'field-kit';

/**
 * 111-111-1111
 * 012345678901 (12 chars)
 */
const PhoneDelimiters = {
  3: '-',
  7: '-'
};

/**
 * 1 111-111-1111
 * 01234567890123 (14 chars)
 */
const PhoneDelimitersWithOne = {
  1: ' ',
  5: '-',
  9: '-'
};

/**
 * +1 111-111-1111
 * 012345678901234 (15 chars)
 */
const PhoneDelimitersWithPlus = {
  2: ' ',
  6: '-',
  10: '-'
};
export default class CanadianPhoneFormatter extends PhoneFormatter {
  guessFormatFromText(text) {
    if (text && text[0] === '+') {
      this.delimiterMap = PhoneDelimitersWithPlus;
      this.maximumLength = 15;
    } else if (text && text[0] === '1') {
      this.delimiterMap = PhoneDelimitersWithOne;
      this.maximumLength = 14;
    } else {
      this.delimiterMap = PhoneDelimiters;
      this.maximumLength = 12;
    }
  }
}